import Logo from '../Logo/Logo';
import Footer from '../Footer/Footer';

function Page ( { children } ) 
{
    return  <>
                <div className="max-w-screen-md m-auto flex flex-col">
                    <div className="p-6">
                        <Logo />
                    </div>
                    <div className="bg-pgteal md:rounded-2xl w-full p-4 sm:p-8">
                        {children}
                    </div>
                    <Footer />
                </div>
            </>
}

export default Page;
